import { getLocationListTitle } from '../../components/Lists/Locations/locationList.helpers';
import { GROUP_SEPARATOR, numberCell, textCell } from './mapper.helpers';

import type { Zone } from 'sonata-static-storage/lib/schemas/zone/zone.schema';
import type { GroupNameResolver, ListExport } from '../export.types';

const HEADERS = [
  'Zone Name',
  'Group',
  'Country',
  'Type',
  'Cartography Level',
  'Cartography ID',
  'Latitude',
  'Longitude',
  'Radius (m)'
];

/** Custom drawn polygons have no lat/lng/radius nor cartography id to export. */
const isCustomPolygon = (zone: Partial<Zone>): boolean => zone.type === 'polygon' && !zone.cartographyLevelId;

const hasRadius = (zone: Partial<Zone>): boolean => zone.type === 'circle' || zone.type === 'torus';

/**
 * Table of the selected (non deleted) locations. Custom polygons are left out and counted in `excludedCount`.
 * `Zone.radius` is already in meters.
 */
export const buildLocationsExport = (
  locations: Partial<Zone>[],
  selectedIds: string[],
  groupNames: GroupNameResolver
): ListExport => {
  const selected = new Set(selectedIds);
  const selectedLocations = locations.filter(zone => !zone.deleted && selected.has(String(zone._id)));
  const exportable = selectedLocations.filter(zone => !isCustomPolygon(zone));
  const rows = exportable.map(zone => [
    getLocationListTitle(zone),
    groupNames(zone.groups).join(GROUP_SEPARATOR),
    textCell(zone.country),
    textCell(zone.type),
    textCell(zone.cartographyLevel),
    textCell(zone.cartographyLevelId),
    numberCell(zone.latlng?.lat),
    numberCell(zone.latlng?.lng),
    hasRadius(zone) ? numberCell(zone.radius) : ''
  ]);
  return { excludedCount: selectedLocations.length - exportable.length, table: { headers: HEADERS, rows } };
};
